module.exports = __webpack_public_path__ + "img/BAY-alt.75d70ab5.svg";